export const FormError = ({ error }: any) => {
    if (!error) return null;

    return <div className="text-sm text-orange-700 mt-1">{error.message}</div>;
};
